var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHenkel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 56,
    viewBox: "0 0 142 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 141,
    height: 55,
    rx: 19.5,
    fill: "url(#paint0_linear_2362_2254)",
    fillOpacity: 0.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 141,
    height: 55,
    rx: 19.5,
    stroke: "#8CBEE4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 130,
    height: 44,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1529 28.0002C35.1529 17.9318 51.2537 9.77293 71 9.77293C90.7462 9.77293 106.847 17.9752 106.847 28.0002C106.847 38.0687 90.7462 46.2276 71 46.2276C51.2103 46.2276 35.1529 38.0253 35.1529 28.0002ZM109.494 28.0002C109.494 16.9337 92.2652 7.9502 71 7.9502C49.7348 7.9502 32.5056 16.9337 32.5056 28.0002C32.5056 39.0668 49.7348 48.0503 71 48.0503C92.2218 48.0503 109.494 39.0668 109.494 28.0002Z",
    fill: "#ED1C24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8743 33.642H42.01V21.6206H44.8743V26.134H49.3009V21.6206H52.1652V33.642H49.3009V28.4775H44.8743V33.642Z",
    fill: "#ED1C24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5355 31.0815C62.8411 33.5552 60.5844 33.9458 58.9353 33.9458C57.7635 33.9458 54.2048 33.6855 54.2048 29.2588C54.2048 26.2209 56.288 24.5718 59.1523 24.5718C63.4487 24.5718 63.6657 28.3475 63.7091 29.389V29.8664H56.9389C56.9389 30.691 57.3295 32.1665 59.0655 32.1665C59.8466 32.1665 60.6278 31.8193 60.8448 31.0815H63.5355ZM60.975 28.4342C60.9316 26.5681 59.7598 26.3077 59.1088 26.3077C58.7617 26.3077 57.1993 26.2643 56.9389 28.4342H60.975Z",
    fill: "#ED1C24"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0056 25.9605C68.7 25.0058 69.8718 24.5718 71.0869 24.5718C72.3021 24.5718 74.038 24.919 74.038 28.1304V33.5987H71.3907V28.5644C71.3907 27.6965 71.3039 26.3077 69.9152 26.3077C68.1792 26.3077 68.1358 28.304 68.1358 28.6946V33.642H65.4885V24.919H68.049V25.9605H68.0056Z",
    fill: "#ED1C24"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.8498 24.9189H85.0178L81.546 28.3474L85.3216 33.642H82.1969L79.7232 29.9965L78.8119 30.9079V33.642H76.1646V21.6206H78.8119V28.2172L81.8498 24.9189Z",
    fill: "#ED1C24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.5764 28.4342C88.8368 26.3077 90.3991 26.3077 90.7463 26.3077C91.3973 26.3077 92.569 26.5681 92.6124 28.4342H88.5764ZM92.4822 31.0815C92.2652 31.8627 91.4407 32.1665 90.7029 32.1665C88.9669 32.1665 88.5764 30.691 88.5764 29.8664H95.3465V29.389C95.3031 28.3475 95.0861 24.5718 90.7897 24.5718C87.882 24.5718 85.8423 26.2209 85.8423 29.2588C85.8423 33.6855 89.4443 33.9458 90.6161 33.9458C92.2652 33.9458 94.5219 33.5552 95.2163 31.0815H92.4822Z",
    fill: "#ED1C24"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.7298 21.6206V33.642H97.0825V21.6206H99.7298Z",
    fill: "#ED1C24"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2362_2254",
    x1: 73.4244,
    y1: 56,
    x2: 73.335,
    y2: -0.00372781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0060B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0060B7",
    stopOpacity: 0.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHenkel);
export default __webpack_public_path__ + "static/media/henkel.e9a3cd32ee81cd57e664939a6c220d75.svg";
export { ForwardRef as ReactComponent };